const breakpointSizes = {
  large: '1366px',
  medium: '992px',
  tablet: '768px',
  mobile: '375px',
}

const variables = {
  breakpoints: {
    large: `@media screen and (max-width: ${breakpointSizes.large})`,
    medium: `@media screen and (max-width: ${breakpointSizes.medium})`,
    tablet: `@media screen and  (max-width: ${breakpointSizes.tablet})`,
    mobile: `@media screen and (max-width: ${breakpointSizes.mobile})`,
    sizes: breakpointSizes,
  },

  borderRadius: '0.25rem',
  borderRadiusLg: '0.5rem',

  buttons: {
    borderRadiusBase: '6.25rem',
    borderRadiusSquare: '0.15rem',
    borderRadiusRound: '2rem',
    widthBase: '6.87rem',
    borderBase: '1px solid #495057',
    fontSizeBase: '0.812rem',
    fontWeightBase: '600',
    startBtBorder: '1px solid #3399FF',

    paddingSize: {
      small: '0.5rem 2.5rem',
      standard: '0.75rem 1.75rem',
      large: '1rem 2.5rem',
    },
  },

  containerMaxWidth: '1366px',

  fontFamily: 'Molde-Regular',
  fontFamilySemibold: 'Molde-Medium',
  fontFamilyBold: 'Molde-Semibold',

  // keep one or the other header font variable, decided when theming is finalized
  fontFamilyHeading: 'SharpSlab',
  fontFamilyHeadingBold: 'SharpSlab-Bold',
  fontFamilyHeadingSemibold: 'SharpSlab-Semibold',
  fontFamilyHeadingExtraBold: 'SharpSlab-Extrabold',

  fontWeightNormal: 400,

  font: {
    size: {
      buttons: {
        base: '1rem',
      },
      headers: {
        h1: '2.25rem',
        h1Large: '3.5rem',
        h2: '1.75rem',
        h2Large: '2.5rem',
        h3: '1.5rem',
        h4: '1.3125rem',
        h5: '1.25rem',
        h6: '1.125rem',
      },
    },
  },

  colors: {
    // palette
    white: '#fff',
    white100: '#E5E5E5',
    gray100: '#F3F3F3',
    gray200: '#e9ecef',
    gray300: '#dee2e6',
    gray400: '#cccccc',
    gray500: '#DDDDDD',
    gray600: '#999999',
    gray700: '#495057',
    gray800: '#343a40',
    gray900: '#212529',
    gray1000: '#979797',
    black: '#000',
    secondStepBlue: '#002855',
    secondStepOrange: '#e1523d',
    navyBlue: '#212b36',
    red: '#ff0000',
    blue: '#3c6e90',
    blueLight: '#f0f1f6',
    darkBlue: '#002855',
    darkerDarkBlue: '#25282A',
    iconBlue: '#0f3964',
    darkGray: '#555555',
    mediumGray: '#666666',
    lightGray: '#999999',
    orange: '#e1523d',
    lightOrange: '#E77564',
    yellow: '#ffbf3f',
    darkYellow: '#cd9933',
    teal: '#487a7b',
    darkTeal: '#2b494a',
    tealKit: '#4B908C',
    tealKitHover: '#165A57',
    pink: '#ff7999',
    successGreen: '#198754',
    errorLightRed: '#FF9999',

    extendGreen: '#01b7ab',
    professionalDevelopmentPurple: '#805acd',
    principalToolkitOrange: '#e17240',

    // TODO: fake colors, can be removed once real theme colors are given from design
    skittlesPink: '#F2059F',
    skittlesBlue: '#05DBF2',
    skittlesGreen: '#04D94F',
    skittlesYellow: '#F2CB05',
    skittlesOrange: '#F28705',

    // links
    linkBase: '#42a5f5',
    linkVisited: '#805aa6',
    grayLink: '#666',
    linkLight: '#ffffff',
    linkLightHover: '#f47b55',

    // backgrounds
    backgroundBody: '#1f1f1f',
    backgroundModalLight: 'rgba(255, 255, 255, 0.8)',
    backgroundModalDark: 'rgba(69,79,91,0.88)',
    backgroundNeutralGray: '#f1f1f1',
    backgroundNeutralGrayOneAccent: '#999',
    backgroundNeutralGrayTwoAccent: '#888',
    backgroundSuccess: '#ebf8dd',
    backgroundInfo: '#e3ebf0',
    backgroundWarning: '#fdf6da',
    backgroundDanger: '#f6cad0',
    backgroundGray: '#eef0f2',

    // fonts
    fontLight: '#fff',
    textTwo: '#454f5b',
    gradeLogo: '#42a5f5',
    gradeLogoHover: '#4A8CE2',

    // borders
    borderBase: '#495057',
    borderDarkGray: '#CED8DF',

    // components
    progressFill: '#eec200',
    progressBackground: '#eff1f3',
    progressInactiveBackground: '#fff',
    classTile: '#212b36',

    tabTitleActive: '#4f90b2',
    tabTitleInactive: '#212b36',
    tabBorder: '#c4cdd5',
    tabUnselect: '#d7d7d7',

    buttonTextBase: '#3e4e57',
    buttonStart: '#3399ff',
    buttonRestart: '#00cc99',
    buttonDisabled: '#112748',
    buttonDisabled100: '#EEF0F2',
    buttonDisabledKit: '#2f495c',

    // forms
    inputPlaceholder: 'rgba(0,0,0,.59)',
    textDanger: '#B8002F',
  },
}

export default variables



// WEBPACK FOOTER //
// ./src/theme/variables.js